"use strict";

define('libs/filter_format/adminCheckinDate',['underscore', 'moment'], function (_, moment) {
  var CHECKIN_VALUE = 'check-in past due';
  var PAST_DUE_FIELD = 'adminCheckinDate';
  var PAST_DUE_START = PAST_DUE_FIELD + 'Start';
  var PAST_DUE_END = PAST_DUE_FIELD + 'End';
  return function (value, model, data) {
    var now = new Date(),
      today = moment([now.getFullYear(), now.getMonth(), now.getDate() + 1]).startOf('day').subtract(1, 'minute').utc(),
      TIME_RE = /(\d+)\s+(.+)/,
      match = null;
    delete data[PAST_DUE_FIELD];
    if (_.isString(value) && (match = value.match(TIME_RE))) {
      data[PAST_DUE_START] = now.getTime();
      data[PAST_DUE_END] = today.add(Number(match[1]), match[2]).toDate().getTime();
    } else if (String(value).toLowerCase() == CHECKIN_VALUE) {
      data[PAST_DUE_END] = now.getTime();
    }
  };
});

